import React from 'react';
import { Inline } from '@styleseat/ui';
import { BodyText, IBodyTextProps } from '../index';

type PropsType = {
  message?: string | React.ReactNode;
  accentColor?: string;
  isJustified?: string;
  testID?: string;
  testIDOverride?: string;
  appearance?: IBodyTextProps['appearance'];
};

const Message = ({
  message,
  accentColor,
  isJustified,
  testID,
  testIDOverride,
  appearance,
}: PropsType) => {
  if (!message) {
    return null;
  }
  if (typeof message === 'string') {
    return (
      <Inline justifyContent={isJustified ? 'center' : undefined}>
        <BodyText
          color={accentColor}
          testID={testIDOverride || (testID && `${testID}-message`)}
          appearance={appearance}
        >
          {message}
        </BodyText>
      </Inline>
    );
  }

  return <React.Fragment>{message}</React.Fragment>;
};

export default Message;
